import { BrowserRouter, Route, Routes } from 'react-router-dom';

import AuthGuard from '@/features/auth/AuthGuard';
import EmailLoginPage from '@/features/auth/EmailLoginPage';
import LoginPage from '@/features/auth/LoginPage';
import RegisterPage from '@/features/auth/RegisterPage';
import VerifyEmailPage from '@/features/auth/VerifyEmailPage';
import ProfilePage from '@/features/profile/ProfilePage';
import AuthCallback from '@/pages/AuthCallback';
import AuthLogout from '@/pages/AuthLogout';
import CheckoutCancelPage from '@/pages/CheckoutCancelPage';
import CheckoutSuccessPage from '@/pages/CheckoutSuccessPage';
import HomePage from '@/pages/HomePage';
import PortalReturnPage from '@/pages/PortalReturnPage';
import ReaderPage from '@/pages/ReaderPage';
import SupportPage from '@/pages/SupportPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public auth routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/email-login" element={<EmailLoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/auth/logout" element={<AuthLogout />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <AuthGuard>
              <HomePage />
            </AuthGuard>
          }
        />
        <Route
          path="/story/:storyId"
          element={
            <AuthGuard>
              <ReaderPage />
            </AuthGuard>
          }
        />
        <Route
          path="/story/:storyId/:nodeId"
          element={
            <AuthGuard>
              <ReaderPage />
            </AuthGuard>
          }
        />
        <Route
          path="/profile"
          element={
            <AuthGuard>
              <ProfilePage />
            </AuthGuard>
          }
        />
        <Route
          path="/support"
          element={
            <AuthGuard>
              <SupportPage />
            </AuthGuard>
          }
        />
        <Route
          path="/checkout/success"
          element={
            <AuthGuard>
              <CheckoutSuccessPage />
            </AuthGuard>
          }
        />
        <Route
          path="/checkout/cancel"
          element={
            <AuthGuard>
              <CheckoutCancelPage />
            </AuthGuard>
          }
        />
        <Route
          path="/portal/return"
          element={
            <AuthGuard>
              <PortalReturnPage />
            </AuthGuard>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
